import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Switches from "vue-switches";
import { CycleModule } from "@/store/modules/cycle.module";
import CycleReview from "./components/CycleReview.vue";
import ReviewComponent from "../reviews/components/ReviewComponent.vue";
let CycleOverview = /** @class */ (() => {
    let CycleOverview = class CycleOverview extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Cycle Overview";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                    href: "#",
                },
                {
                    text: "Cycles",
                    to: "/performance/cycles",
                },
                {
                    text: "Cycle Overview",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "CycleListing",
                },
            ];
            this.pageIsLoading = true;
        }
        get cycleReviews() {
            return CycleModule.cycleOverView;
        }
        reviewCardClicked(review) {
            console.log("sideeye");
            // let reviewComponent = this.$refs["reviewComponentRef"] as ReviewComponent;
            // reviewComponent.ShowNonInteractiveReviewModal(review.id);
        }
        wiring(reviewId, isMeetingSelected) {
            let reviewComponent = this.$refs["reviewComponentRef"];
            reviewComponent.ShowNonInteractiveReviewModal(reviewId, isMeetingSelected);
        }
        autoNudge() {
            var cycleId = this.$route.params.cycleId;
            CycleModule.UpdateAutoNudge({ cycleId: cycleId, enableAutoNudge: this.cycleReviews.autoNudge }).then((res) => {
                if (res) {
                    // toaster.ShowSuccess("auto Nudge is updated sucessfully.");
                }
            });
        }
        created() {
            var cycleId = this.$route.params.cycleId;
            CycleModule.GetCycleOverView(cycleId).then((response) => {
                if (response) {
                    this.pageIsLoading = false;
                }
            });
        }
    };
    CycleOverview = __decorate([
        Component({
            name: "CycleOverview",
            components: {
                Layout,
                PageHeader,
                Loader,
                ReviewComponent,
                CycleReview,
                Switches,
            },
        })
    ], CycleOverview);
    return CycleOverview;
})();
export default CycleOverview;
